import { docType } from "../enums";

export var documentType = [
    { value: 0, label: "Select" },
    { value: docType.PrivacyPolicy, label: "Privacy Policy" },
    { value: docType.TermsOfUse, label: "Terms of Use" },
    { value: docType.UserAgreement, label: "User agreement"},
    { value: docType.Litepaper, label: "Litepaper"}
  ];